<template>
  <div class="homeEmpresa" style="padding-top: 0">
    <div class="auto-container">
      <div class="flex flex-wrap w-full">
        <div class="content-column flex w-full lg:w-4">
          <div class="inner-column">
            <div class="homepage-title-group">
              <span class="sectionTitle" v-html="titulo"></span>
              <div class="subtitulo" v-html="subtitulo"></div>
              <div @click="fc_goRoute('sobreNos')" class="btn-redireciona" v-html="fc_getText(null,'btn_conhecaIbase')"></div>
            </div>
          </div>
        </div>
        <!--Carousel Sobre Nos Imagens -->
        <div class="carousel-column flex w-full lg:w-8">
          <Carousel :value="imagens" :numVisible="1" :numScroll="1" circular :autoplayInterval="3000">
            <template #item="slotProps">
              <div class="border border-surface-200 dark:border-surface-700 rounded">
                <div>
                  <div class="relative mx-auto">
                    <a @click="fc_goRoute('sobreNos')"><img :src="slotProps.data.imagem" class="rounded" /></a>
                  </div>
                </div>
              </div>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    titulo: String,
    subtitulo: String,
    imagens: Object
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<style scoped>
  .homeEmpresa {
    position: relative;
    padding: 140px 0 75px;
  }
  .homeEmpresa .homepage-title-group {
    margin-bottom: 40px;
  }
  .homeEmpresa .homepage-title-group .subtitulo {
    padding-bottom: 80px;
    font-size: 24px;
    color: #777777;
    font-weight: normal;
    margin: 0px;
    line-height: 1.2em;
  }
  .homeEmpresa .content-column,
  .homeEmpresa .carousel-column {
    padding-right: 15px;
    padding-left: 15px;
  }
  .homeEmpresa .p-carousel-item img {
    width: 100%;
    max-height: 100%;
    height: 410px;
    display: block;
    object-fit: contain;
  }
  .homeEmpresa .carousel-column {
    position:relative;
  }
  @media only screen and (max-width: 767px) {
    .homeEmpresa {
      padding-top: 70px;
      padding-bottom: 0;
    }
}
</style>
